<template>
    <div id="add-residence-term">
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-btn :color="primaryColor" dark small v-bind="attrs" v-on="on"
                    @click.stop="openAddResidenceTermDialog()">
                    <v-icon>mdi-calendar-plus</v-icon>
                </v-btn>
            </template>
            <span>Add Residence Term</span>
        </v-tooltip>
        <v-dialog v-model="addResidenceTermDialog" max-width="767" persistent>
            <v-card>
                <v-card-title>
                    Add Residence Term
                </v-card-title>
                <v-card-text>
                    <v-form ref="addResidenceTermForm" v-model="valid" lazy-validation>
                        <v-text-field v-model="currentResidenceTerm.term" label="Term" :rules="termRules" required>
                        </v-text-field>
                        <v-container fluid class="pa-0">
                            <v-row no-gutters>
                                <v-col cols="12" md="6" class="pt-0">
                                    <v-menu ref="startDate" v-model="startDateMenu" :close-on-content-click="false"
                                        transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="currentResidenceTerm.startDate" id="startDate"
                                                :color="successColor" label="Term Start Date" name="startDate"
                                                prepend-icon="mdi-calendar-check" readonly :rules="startDateRules"
                                                v-bind="attrs" v-on="on">
                                            </v-text-field>
                                        </template>
                                        <v-date-picker v-model="currentResidenceTerm.startDate" :color="successColor"
                                            :max="currentResidenceTerm.endDate" no-title @input="startDateMenu = false"
                                            @change="setTerm">
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" md="6" class="pt-0">
                                    <v-menu ref="endDate" v-model="endDateMenu" :close-on-content-click="false"
                                        transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="currentResidenceTerm.endDate" id="endDate"
                                                :color="dangerColor" label="Term End Date" name="endDate"
                                                prepend-icon="mdi-calendar-remove" readonly :rules="endDateRules"
                                                v-bind="attrs" v-on="on">
                                            </v-text-field>
                                        </template>
                                        <v-date-picker v-model="currentResidenceTerm.endDate" :color="dangerColor"
                                            :min="currentResidenceTerm.startDate" no-title @input="endDateMenu = false"
                                            @change="setTerm">
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                            </v-row>
                        </v-container>
                        <v-menu ref="moveInDate" v-model="moveInDateMenu" :close-on-content-click="false"
                            transition="scale-transition" offset-y max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="currentResidenceTerm.moveInDate" id="moveInDate"
                                    :color="primaryColor" label="Move-In Date" name="moveInDate"
                                    prepend-icon="mdi-calendar-heart" readonly :rules="moveInDateRules" v-bind="attrs"
                                    v-on="on">
                                </v-text-field>
                            </template>
                            <v-date-picker v-model="currentResidenceTerm.moveInDate" :color="primaryColor" no-title
                                :max="currentResidenceTerm.endDate" @input="moveInDateMenu = false">
                            </v-date-picker>
                        </v-menu>
                        <v-select v-model="currentResidenceTerm.active" :items="activeItems" label="Active"
                            :rules="activeRules" required>
                        </v-select>
                        <v-select v-model="currentResidenceTerm.default"
                            hint="Set as default choice for the Online Residence Application form" :items="defaultItems"
                            label="Default" persistent-hint :rules="defaultRules" required>
                        </v-select>
                        <v-textarea v-model="currentResidenceTerm.notes" auto-grow class="pt-5" label="Notes" outlined>
                        </v-textarea>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn ref="addBtn" class="white--text" :color="successColor" :disabled="!valid"
                        @click="openAddResidenceTermConfirmationDialog()">
                        Add
                    </v-btn>
                    <v-btn ref="resetBtn" class="white--text" :color="primaryColor" @click="resetForm()">
                        Reset
                    </v-btn>
                    <v-btn ref="closeBtn" :color="warningColor" @click="closeAddResidenceTermDialog()">
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="addResidenceTermConfirmationDialog" max-width="540">
            <v-card ref="addResidenceTermConfirmationCard">
                <v-card-title>Confirmation</v-card-title>
                <v-card-text>
                    Are you sure you would like to add <b>{{ currentResidenceTerm.term }}</b> as a Residence Term?
                    Please click
                    confirm to proceed.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn ref="confirmBtn" :color="dangerColor" text @click="addResidenceTerm()">
                        Confirm
                    </v-btn>
                    <v-btn :color="warningColor" text @click="closeAddResidenceTermConfirmationDialog()">
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: 'residence-terms-add',
    data() {
        return {
            activeItems: [{
                    text: 'Yes',
                    value: '1'
                },
                {
                    text: 'No',
                    value: '0'
                }
            ],
            activeRules: [
                v => !(v === "") || 'Active is required',
            ],
            addResidenceTermDialog: false,
            addResidenceTermConfirmationDialog: false,
            currentResidenceTerm: {
                active: '1',
                default: '0',
                endDate: '',
                notes: '',
                moveInDate: '',
                startDate: '',
                term: ''
            },
            defaultItems: [{
                    text: 'Yes',
                    value: '1'
                },
                {
                    text: 'No',
                    value: '0'
                }
            ],
            defaultRules: [
                v => !(v === "") || 'Default is required',
            ],
            endDateMenu: false,
            endDateRules: [
                v => !!v || 'End date is required',
            ],
            months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
            moveInDateMenu: false,
            moveInDateRules: [
                v => !!v || 'Move in date is required',
            ],
            termRules: [
                v => !!v || 'Term is required',
                v => (v && v.length >= 2) || 'Term must be more than 2 characters',
            ],
            startDateMenu: false,
            startDateRules: [
                v => !!v || 'Start date is required',
            ],
            valid: true
        }
    },
    methods: {
        addResidenceTerm() {
            const that = this;
            const formData = new FormData();
            let api = `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?updateEntity`;

            // Parse array into string
            formData.append('data', JSON.stringify(this.currentResidenceTerm));
            formData.append('mode', 'updateEntity');
            formData.append('type', 'ResidenceTerms');

            // Loading icon
            this.$refs.confirmBtn.loading = true;

            // Post request
            fetch(api, {
                    method: 'POST',
                    body: formData
                })
                .then(function (response) {
                    // Return JSON response
                    return response.json();
                })
                .then(function (json) {
                    // Success result
                    if (json.result.match(/OK/i)) {
                        that.$emit('setNotification', '#1dc9b7', 'mdi-check-circle', `${that.currentResidenceTerm.term} has been successfully added as a Residence Term.`, true);
                    } else if (json.message.match(/UNAUTHORIZED/i)) {
                        that.$emit('setNotification', '#f64e60', 'mdi-alert-outline', `You are not authorized to perform this action. Please refresh your application.`, true);
                    } else {
                        that.$emit('setNotification', '#ffb822', 'mdi-alert-circle', `${that.currentResidenceTerm.term} could not be added as a Residence Term. Please contact your system administrator.`, true);
                    }

                    that.$emit('refreshData');
                    that.$refs.confirmBtn.loading = false;
                    that.closeAddResidenceTermConfirmationDialog();
                    that.closeAddResidenceTermDialog();
                })
                .catch(function () {
                    that.$emit('refreshData');
                    that.$refs.confirmBtn.loading = false;
                    that.$emit('setNotification', '#f64e60', 'mdi-alert-outline', `An error occurred. Please contact your system administrator.`, true);
                });
        },
        closeAddResidenceTermConfirmationDialog() {
            this.addResidenceTermConfirmationDialog = false;
        },
        closeAddResidenceTermDialog() {
            this.addResidenceTermDialog = false;
        },
        openAddResidenceTermConfirmationDialog() {
            // Validate form before confirmation
            if (this.$refs.addResidenceTermForm.validate()) {
                this.addResidenceTermConfirmationDialog = true;
            }
        },
        openAddResidenceTermDialog() {
            // Reset form
            this.resetForm();
            this.addResidenceTermDialog = true;
        },
        resetForm() {
            // Reset form validation
            this.resetFormValidation();

            // Reset current residence term
            this.currentResidenceTerm.active = '1';
            this.currentResidenceTerm.default = '0';
            this.currentResidenceTerm.endDate = '';
            this.currentResidenceTerm.notes = '';
            this.currentResidenceTerm.startDate = '';
            this.currentResidenceTerm.term = '';
        },
        resetFormValidation() {
            if (this.$refs.addResidenceTermForm) {
                this.$refs.addResidenceTermForm.resetValidation();
            }
        },
        setTerm() {
            if (this.currentResidenceTerm.startDate && this.currentResidenceTerm.endDate) {
                let endDate = this.currentResidenceTerm.endDate.split("-");
                let startDate = this.currentResidenceTerm.startDate.split("-");
                this.currentResidenceTerm.term = `${this.months[parseInt(startDate[1]) - 1]} ${startDate[0]} - ${this.months[parseInt(endDate[1]) - 1]} ${endDate[0]}`;
            } else if (this.currentResidenceTerm.startDate && !this.currentResidenceTerm.endDate) {
                let startDate = this.currentResidenceTerm.startDate.split("-");
                this.currentResidenceTerm.term = `${this.months[parseInt(startDate[1]) - 1]} ${startDate[0]} - Term end date`;
            } else if (this.currentResidenceTerm.endDate && !this.currentResidenceTerm.startDate) {
                let endDate = this.currentResidenceTerm.endDate.split("-");
                this.currentResidenceTerm.term = `Term start date - ${this.months[parseInt(endDate[1]) - 1]} ${endDate[0]}`;
            }
        }
    },
    computed: {
        dangerColor() {
            return '#f64e60';
        },
        primaryColor() {
            return '#5867dd';
        },
        successColor() {
            return '#1dc9b7';
        },
        warningColor() {
            return '#ffb822'
        }
    }
}
</script>